export const isNoneOfTheAboveOption = (option: string): boolean => option.trim().toLowerCase() === 'none of the above';
